import React from 'react';
import { Box, Divider, Grid, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Edit } from '@mui/icons-material';
import ImageContainer from '../Shared/ImageContainerBox';
import { useTranslation } from '../../hooks/useTranslation';
// import Link from '@mui/material/Link';


const CartComponent = ({ cartItem }) => {
  const { order, customerInfo } = cartItem;
  const theme = useTheme();
  const { t } = useTranslation();

  const translateSize = (size) => {
    if (size === 'Small') return t('small');
    if (size === 'Large') return t('large');
    if (size === 'One Size') return t('oneSize');
    return size;
  };

  return (
    <div>
      <Box
        sx={{
          height: '50vh',
          minHeight: '400px',
          padding: 2,
          border: '1px solid #ccc',
          display: 'flex',
          flexDirection: 'column',
          // justifyContent: 'space-between',
          // overflow: 'auto',
          backgroundColor: theme.palette.component.componentBackground
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 2,
          }}
        >
          <Typography variant="body2" component="p" sx={{ textAlign: 'left', fontWeight: 'bold', mb: 2 }}>
            {order.length} {order.length === 1 ? t('item') : t('items')}
          </Typography>
          <IconButton href="/cart">
            <Edit sx={{ "&:hover": { color: theme.palette.common.blue } }} />
          </IconButton>
        </Box>

        <Divider variant="middle" sx={{ margin: '10px 0px' }}/>

        <Box sx={{ overflow: 'auto', flexGrow: 1, paddingLeft: '7px', backgroundColor: theme.palette.common.offWhite }}>
          {order.map((cartItem, index) => (
            <div key={index}> 
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <ImageContainer sx={{ paddingRight: "20px" }} itemName={cartItem.itemName} itemImage={cartItem.itemImage} />
                </Grid>

                <Grid item xs={8}>
                  <Grid container direction="column" spacing={0} sx={{ paddingTop: "20px" }}>
                    <Grid item sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span>
                        <Typography variant="p" sx={{ textAlign: "left" }}>
                          {`${cartItem.itemPrice} ${t('currency')}`}
                        </Typography>
                      </span>
                    </Grid>
                    <Grid item>
                      <Typography variant="body2" gutterBottom sx={{ textAlign: "left", paddingRight: '7px' }}>
                        {cartItem.itemName}
                      </Typography>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={5}>
                        <Typography variant="body2" gutterBottom sx={{ textAlign: "left" }}>
                          {translateSize(cartItem.itemSize)}
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography variant="body2" gutterBottom sx={{ textAlign: "left" }}>
                          Qty: {cartItem.itemQuantity}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {cartItem.specialInstructions && cartItem.specialInstructions.trim() !== "" ?
                  <>
                  <Grid item xs={11} sx={{ paddingBottom: '15px', marginLeft: '10px', mt: -2.5 }}>
                    <Typography variant="body3" gutterBottom sx={{ textAlign: "left", fontStyle: "italic", color: theme.palette.common.grey}}>
                      <b>Notes: </b> {cartItem.specialInstructions}
                    </Typography>
                  </Grid>
                  </>
                : null}
              </Grid>
              {index !== order.length - 1 && <Divider variant="middle" />}
            </div>
          ))}
        </Box>

        <Divider variant="middle" sx={{ margin: '10px 0px' }}/>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 2,
            width: '100%',
          }}
        >
          <Typography variant="body2" component="p" sx={{ fontWeight: 'bold', mb: 2 }}>
            {t('paymentMethod')}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>

              {/* <Link href="/cart" underline="none" sx={{ }}>
                <Typography variant="body2" component="p" sx={{ color: theme.palette.common.blue, mb: 2 }}>
                  {"(edit)"}
                </Typography>
              </Link> */}
              <Typography variant="body2" component="p" sx={{ mb: 2, marginLeft: '10px' }}>
                {customerInfo.paymentMethod === 'inPerson' ? 'In Person' : 'Online'}
              </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 2,
            width: '100%',
          }}
        >
          <Typography variant="body2" component="p" sx={{ fontWeight: 'bold', mb: 2 }}>
            {t('totalToPay')}
          </Typography>
          <Typography variant="body2" component="p" sx={{ mb: 2 }}>
            {`${order.reduce((acc, item) => acc + item.itemQuantity * item.itemPrice, 0)} ${t('currency')}`}
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default CartComponent;